import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { TextInput } from "./";
import { FormattedMessage } from "react-intl";

const IntlFieldGroup = (props) => {
  const { field, labelKey, localizations, className, isArchived, readOnly } = props;
  let { type } = props;
  let rest = {};
  if (type == "textarea") {
    type = "text";
    rest = { componentClass: "textarea" };
  }

  const localizedFields = Object.keys(localizations).map((locale, index) => {
    const fieldName = `localizations[${locale}].${field}`;
    const label = !index ? <FormattedMessage id={labelKey} /> : " ";
    const required = !index && props.required;

    return (
      <Field
        className={className}
        groupClassName={`intl ${locale.substr(0, 2)} ${props.type}`}
        key={fieldName}
        id={fieldName}
        name={fieldName}
        required={required}
        type={type}
        {...rest}
        component={TextInput}
        disabled={isArchived || readOnly}
        label={label}
      />
    );
  });

  return <div className="intl-field-group">{localizedFields}</div>;
};

IntlFieldGroup.propTypes = {
  className: React.PropTypes.string,
  field: React.PropTypes.string.isRequired,
  labelKey: React.PropTypes.string.isRequired,
  localizations: React.PropTypes.object.isRequired,
  type: React.PropTypes.string,
  isArchived: React.PropTypes.bool,
  readOnly: React.PropTypes.bool,
  required: PropTypes.bool,
};

IntlFieldGroup.defaultProps = {
  type: "text",
};

export default IntlFieldGroup;



// WEBPACK FOOTER //
// ./src/components/common/form/IntlFieldGroup.js